import { storage } from "@/modules/storage";

import { PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY, PROMOTION_MODAL_SEEN_KEY } from "../constants";

const readAcknowledgedIds = (): string[] => {
  const raw = storage.getItem(PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY);
  if (!raw) {
    return [];
  }

  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((id): id is string => typeof id === "string");
  } catch {
    return [];
  }
};

const writeAcknowledgedIds = (ids: string[]) => {
  const unique = [...new Set(ids)];
  if (unique.length === 0) {
    storage.removeItem(PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY);
    return;
  }
  storage.setItem(PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY, JSON.stringify(unique));
};

/**
 * Users who dismissed under the old boolean flag should not see currently-active
 * popups again. New campaigns published later still surface (their ids were not
 * present at reconciliation time).
 */
export const reconcileLegacyPopupAcknowledgment = (activePromotionIds: string[]) => {
  if (storage.getItem(PROMOTION_MODAL_SEEN_KEY) !== "true") {
    return;
  }

  if (activePromotionIds.length > 0) {
    const existing = readAcknowledgedIds();
    writeAcknowledgedIds([...existing, ...activePromotionIds]);
  }

  storage.removeItem(PROMOTION_MODAL_SEEN_KEY);
};

export const getAcknowledgedPopupPromotionIds = (): string[] => {
  return readAcknowledgedIds();
};

export const acknowledgePopupPromotionIds = (promotionIds: string[]) => {
  if (promotionIds.length === 0) {
    return;
  }
  const existing = readAcknowledgedIds();
  writeAcknowledgedIds([...existing, ...promotionIds]);
  storage.removeItem(PROMOTION_MODAL_SEEN_KEY);
};

export const clearAcknowledgedPopupPromotionIds = () => {
  storage.removeItem(PROMOTION_MODAL_ACKNOWLEDGED_IDS_KEY);
  storage.removeItem(PROMOTION_MODAL_SEEN_KEY);
};

export const filterUnacknowledgedPopupPromotionIds = (promotionIds: string[]): string[] => {
  const acknowledged = new Set(getAcknowledgedPopupPromotionIds());
  return promotionIds.filter((id) => !acknowledged.has(id));
};

export const hasUnacknowledgedPopups = (promotionIds: string[]): boolean => {
  return filterUnacknowledgedPopupPromotionIds(promotionIds).length > 0;
};
